import * as React from "react";

import { Label, RequiredMark } from "@/components/ui/label";
import { cn } from "@/lib/utils";

/** Input・Select・Textarea が共有するフィールド外枠と状態表現。 */
const formControlClassName =
  "border-input shadow-xs dark:bg-input/30 w-full min-w-0 rounded-md border bg-transparent outline-none transition-[color,box-shadow] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive";

function FormField({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="form-field"
      className={cn("grid content-start gap-1.5", className)}
      {...props}
    />
  );
}

type FormFieldLabelProps = React.ComponentProps<typeof Label> & {
  required?: boolean;
};

function FormFieldLabel({
  className,
  children,
  required = false,
  ...props
}: FormFieldLabelProps) {
  return (
    <Label className={className} required={required} {...props}>
      {children}
    </Label>
  );
}

function FormFieldDescription({
  className,
  ...props
}: React.ComponentProps<"p">) {
  return (
    <p
      data-slot="form-field-description"
      className={cn("text-muted-foreground -mt-0.5 text-xs", className)}
      {...props}
    />
  );
}

function FormFieldError({
  className,
  children,
  ...props
}: React.ComponentProps<"p">) {
  if (!children) return null;

  return (
    <p
      data-slot="form-field-error"
      role="alert"
      className={cn("text-destructive -mt-0.5 text-sm", className)}
      {...props}
    >
      {children}
    </p>
  );
}

export {
  FormField,
  FormFieldDescription,
  FormFieldError,
  FormFieldLabel,
  RequiredMark,
  formControlClassName,
};
